import { FaGithub } from '../deps/react-icons-fa6.js'

import type { IconProps } from '../types.js'

export type GithubIconProps = Omit<IconProps, 'name'>

const GithubIcon = ({ className, size = 24 }: GithubIconProps) => {
  return <FaGithub className={className} size={size} />
}

export default GithubIcon
